<script>
  import page from "page";
  import { status } from "./status.js";
  import { onMount } from 'svelte';

  var	positionArray  = [], quickLinks  = [];

  function doNavigation(url) {
    window.scrollTo(0,0);
    page(url);
  }

	onMount(() => {

    $status.notification.show = false;
    $status.notification.confirm = false;
  
    var	 hashArray  = [], isActive = '';
    quickLinks = document.querySelectorAll(".menu-list a");

    for (var i=0; i<quickLinks.length; i++){
      hashArray.push(quickLinks[i].href.substring(quickLinks[i].href.indexOf('#')+1));
    }

    for (var i=0; i<hashArray.length; i++){
      positionArray.push(document.getElementById(hashArray[i]).getBoundingClientRect().top);
    }

    document.addEventListener("scroll", scrollHandler, true);
    
    for (var i=0; i<quickLinks.length; i++){
      quickLinks[i].addEventListener('click', function(event){
        document.removeEventListener('scroll', scrollHandler, true);

        isActive = document.querySelectorAll(".menu-list a.is-active")[0];

        if (isActive != undefined){
          isActive.classList.remove('is-active');
        }

        this.classList.add('is-active');

        setTimeout(function(){
                document.addEventListener("scroll", scrollHandler, true); 
        }, 1000); 
      });
    }
	});




function scrollHandler() {


  var currentScrollPosition = document.documentElement.scrollTop;

	for (var i=1; i<=positionArray.length; i++){

		if (currentScrollPosition>=positionArray[i-1] && currentScrollPosition < positionArray[i]) {

        var currentActive = document.querySelectorAll(".menu-list a.is-active")[0];
            
				if (currentActive != undefined){
          currentActive.classList.remove('is-active');
        }
			
			quickLinks[i-1].classList.add('is-active');

			break;

		}

		if (currentScrollPosition>positionArray[positionArray.length-1]){

      var currentActive = document.querySelectorAll(".menu-list a.is-active")[0];

      if (currentActive != undefined){
        currentActive.classList.remove('is-active');
      }
      quickLinks[quickLinks.length-1].classList.add('is-active');

      break;

		}
	}
};


</script>

<style>

/* .is-horizonal-center{
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.has-shadow{
  box-shadow: 0px 3px 6px #2F3E4D1A;;
}

.documentation section{

    margin-bottom: 4rem;;
} */

/* .main {
	scroll-behavior: smooth;
} */

p {
	margin-bottom: 25px;
}

.sticky	{
	position: sticky;
  top: 80px;
}

.content h2.title:not(:first-child) { 
  padding-top: 6rem; 
}



</style>

<svelte:head>
  <title>ZaaS - Documentación</title>
</svelte:head>

 <section class="main">

    <div class="container">

      <div class="columns">

        <div class="column content is-three-fifths">
          <h1 class="is-size-1 has-text-primary">Documentación</h1>
          <h2 id="introduction" class="title has-text-primary">Introducción</h2>
          <p>Integrar cualquier aplicación con ZaaS es idéntico a integrarla con una instancia privada de ZofToken, por lo cual la mayor parte de la información está disponible en la <a href="https://zoftoken.com/doc" target="_blank">documentación general</a>.
          Visto a la inversa, utilizar una subscripción gratuita para experimentar y/o realizar pruebas puede considerarse una buena práctica durante la implementación de una instancia privada.
          </p>

          <p>Debe tenerse en cuenta que el componente "Mis Usuarios" de ZaaS es esencialmente una interface gráfica para la API de ZofToken, de modo que todas las operaciones relacionadas a los tokens (creción, lectura y administración de estado, 
          utilización de la autenticación fuera de línea y borrado) pueden realizarse tanto de la UI de ZaaS como a través de la API.</p>
          
          <h2 id="integration"  class="title has-text-primary">Detalles de integración</h2>
          <h5 class="is-secondary"><b>Nombres de usuario</b></h5 >
          <p>El nombre de usuario de cada token, como se muestra en ZaaS, corresponderá al campo "id" en la mayoría de los llamados a la API.
          </p>
          <h5 class="is-secondary"><b>Nombres de servicio</b></h5 >
          <p>Todos los servicios configurados en ZaaS tendrán como prefijo el nombre de su subscripción, de modo que si la subscripción se llama "subscripcióndeprueba" y un servicio se llama "serviciodeprueba", el campo "service" para la mayoría de los
          llamados a la API deberá ser "subscripcióndeprueba_serviciodeprueba". La interface de usuario de ZaaS muestra claramente el identificador que debe usarse en la página "Mis Servicios".
          </p>
          <h5 class="is-secondary"><b>Authkeys</b></h5 >
          <p>Cada servicio en ZaaS muestra dos authkeys (que pueden ser copiadas directamente al portapapeles del sistema):</p>
              <ul>
                  <li>Básico: este authkey solamente permitirá consultar a la API por el estado de los tokens que formen parte del mismo.
                  </li>
                  <li>Administrativo: este authkey permitirá ejecutar todas las funciones de la API para los tokens que formen parte del mismo.
                  </li>
              </ul>

          <h5 class="is-secondary"><b>Llamadas a la API</b></h5 >
          <p>Todas las llamadas a la API para las subscripciones de ZaaS deben ser enviadas a la siguiente URL:
          </p>
          <p><b>https://zaas.zoftoken.com/token</b>
          </p>

          <h2 id="examples" class="title has-text-primary">Ejemplos</h2>

          <h5 class="is-secondary"><b>Configurar Windows 10 PRO para usar un ZofToken durante el acceso inicial de un usuario</b></h5>

                    <i>En ZaaS</i>
                        <ol>
                            <li>Crear un servicio en la subscripción con los parámetros estándares (se recomienda utilizar el nombre del equipo a acceder).</li>
                            <li>Crear el usuario o usuarios necesarios y completar el proceso de enrolamiento en la app de ZofToken (los usuarios deben ser creados con el mismo nombre utilizado en Windows).
                            </li>
                        </ol>
                    
                    <i>En Windows</i>
                        
                        <ol>
                            <li>Crear un archivo de texto (por ejemplo con el Bloc de Notas) con el siguiente contenido:</li>

                        <div class="code-block">
                        <!-- HTML generated using hilite.me -->
<!-- <div style="background: #ffffff; overflow:auto;width:auto;border:solid gray;border-width:.1em .1em .1em .8em;padding:.2em .6em;"> -->
<pre style="margin: 0; line-height: 125%"><span style="color: #996633">$user</span> = <span style="color: #996633">$env:USERNAME</span>
<span style="color: #008800; font-weight: bold">if</span> (! <span style="color: #996633">$user</span>.Equals(<span style="background-color: #fff0f0">&quot;ONE&quot;</span>)) &lbrace;
  <span style="color: #996633">$wshell</span> = <span style="color: #007020">New-Object</span> -ComObject Wscript.Shell
  <span style="color: #003366; font-weight: bold">[Net.ServicePointManager]</span>::SecurityProtocol = <span style="color: #003366; font-weight: bold">[Net.SecurityProtocolType]</span>::Tls12
  <span style="color: #996633">$tokenCheck</span> = <span style="color: #007020">Invoke-WebRequest</span> -UseBasicParsing -Uri https://zaas.zoftoken.com/token/status<span style="color: #008800; font-weight: bold">?</span>id=<span style="color: #996633">$user</span><span style="background-color: #fff0f0">&quot;&amp;&quot;</span>service=TWO<span style="background-color: #fff0f0">&quot;&amp;&quot;</span>authKey=THREE
  <span style="color: #996633">$tokenStatus</span> = <span style="color: #996633">$tokenCheck</span>.Content.Substring(10,1)
  <span style="color: #008800; font-weight: bold">if</span> (! <span style="color: #996633">$tokenStatus</span>.Equals(<span style="background-color: #fff0f0">&quot;1&quot;</span>)) &lbrace;
    <span style="color: #996633">$wshell</span>.Popup(<span style="background-color: #fff0f0">&quot;Your ZofToken is currently closed - access to this account is denied&quot;</span>, 5)
    logoff
  }
}
</pre>
<!-- </div> -->
                        </div>
                    
                            <li>Editar los parámetros UNO, DOS y TRES del siguiente modo:
                                    <ul>
                                        <li>UNO: un nombre del usuario del equipo que NO utilizará 2FA - esto es una contingencia en el caso de que algún problema (p.e. falta de acceso a internet) impida usar ZofToken.
                                        </li>
                                        <li>DOS: el servicio configurado previamente (por ejemplo, misubscripcion_mipc).
                                        </li>
                                        <li>TRES: el “Authkey Básico” que fue creado al azar para el servicio.
                                        </li>
                                    </ul>
                            </li>    
                            <li>Guardar el archivo como “zoftoken.ps1” en algún lugar (por ejemplo, en el Escritorio).
                            </li>
                            <li>Abrir el <b>Editor de directivas de grupo local</b> (puede buscarlo en el Menu Inicio).
                            </li>
                            <ol>
                              <li>Ir a Configuración del equipo - Plantillas administrativas - Componentes de Windows - Windows Powershell.
                              </li>
                              <li>Haga doble click en “Activar la ejecución de scripts” y una vez que aparece la nueva ventana seleccione "Habilitado" (arriba a la izquierda), luego seleccione "Permitir todos los scripts" (bajo Opciones: Directiva de Ejecución) y haga click en Aceptar.
                              </li>
                              <li>Vuelva a la pantalla original y vaya a Configuración de usuario – Configuración de Windows – Scripts (inicio de sesión o cierre de sesión) – Inicio de sesión.
                              </li>
                              <li>Vaya a la sección de “Scripts de PowerShell”.
                              </li>
                              <li>Haga click on “Mostrar archivos” en la parte baja de la ventana y copie el archivo que creo anteriormente dentro de la carpeta que aparece (en el caso de que se le soliciten permisos de administrador, haga click en Aceptar).
                              </li>
                              <li>En la ventana de configuración previa, haga click en Agregar y luego haga click en Examinar, seleccione el archivo “zoftoken.ps1” que acaba de copiar y haga click en Aceptar.
                              </li>
                              <li>Haga click en Aplicar y luego en Aceptar para cerrar la ventana.
                              </li>
                            </ol>
                            <li>La proxima vez que cualquier usuario ingrese en el equipo (excepto el usuario de contingencia que definió previamente en el parámetro "UNO") deberá tener su ZofToken abierto o de lo contrario recibirá una advertencia de seguridad y será desconectado.
                            </li>
                        </ol>

          <h5 class="is-secondary"><b>Usar un ZofToken para autorizar pasajes a producción en una herramienta de Integración Continua</b></h5>

                    Liberamos un plugin disponible publicamente para Drone CI que puede ser incluido en cualquier pipeline como un paso de verificación/validación.
                    <p></p>

                    <i>En ZaaS</i>
                        <ol>
                            <li>Crear un servicio en la subscripción con los parámetros estándares.</li>
                            <li>Crear el usuario o usuarios que deberán autorizar la ejecución de los pipelines de Drone CI (usualmente pasajes a producción de servicios/aplicaciones).
                            </li>
                        </ol>
                    
                    <i>En Drone CI</i>
                        <ul>
                            <li>El plugin está disponible en Dockerhub por lo que puede ser utilizado directamente como una imagen en pipelines basados en Docker.</li>
                            <li>Por favor siga la <a href="https://hub.docker.com/r/zoftoken/drone">documentación</a> (en inglés) para configurar su pipeline como sea necesario.</li>
                        </ul>

        </div>

        <div class="column"></div>

        <div class="column">
          <div class="menu sticky is-documentation">
            <h4 class="menu-label is-size-6">Tabla de contenidos</h4>
            <ul id="menu" class="menu-list">
              <li><a href="#introduction">Introducción</a></li>
              <li><a href="#integration">Detalles de integración</a></li>
              <li><a href="#examples">Ejemplos</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div> 
    <!-- end container -->

  </section>


